import { marmeladze, mirrorVideo, okak, paris } from "../../assets/images";
import styles from "./Gallery.module.scss";
import { PreloadedImage } from "../../shared/components/PreloadedImage";
function Gallery() {
  return (
    <div className={styles.right}>
      <div className={styles.grid}>
        <PreloadedImage
          src={marmeladze}
          alt="Мармеалми и мармеладзе"
          className={styles.character}
          width={240}
          height={201}
        />
        <PreloadedImage
          src={okak}
          alt="Окак"
          className={styles.character}
          width={240}
          height={253}
        />

        <PreloadedImage
          src={paris}
          alt="Алми в Париже"
          className={styles.character}
          width={241}
          height={302}
          customContainerClass={styles.lastImageContainer}
        />
      </div>
      <div className={styles.videoCell}>
        <video src={mirrorVideo} autoPlay loop muted playsInline />
      </div>
    </div>
  );
}

export default Gallery;
